// Generated by purs version 0.15.15
import * as Data_Bounded_Generic from "../Data.Bounded.Generic/index.js";
import * as Data_Enum_Generic from "../Data.Enum.Generic/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Map_Serialized from "../Data.Map.Serialized/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Generic_EnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Enum from "../Unscramble.Enum/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(Data_Money_Rounded.eqMoney);
var cardAmountIsSymbol = {
    reflectSymbol: function () {
        return "cardAmount";
    }
};
var cashAmountIsSymbol = {
    reflectSymbol: function () {
        return "cashAmount";
    }
};
var SplitPaymentInfoIsSymbol = {
    reflectSymbol: function () {
        return "SplitPaymentInfo";
    }
};
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var CashIsSymbol = {
    reflectSymbol: function () {
        return "Cash";
    }
};
var OnlineIsSymbol = {
    reflectSymbol: function () {
        return "Online";
    }
};
var CardIsSymbol = {
    reflectSymbol: function () {
        return "Card";
    }
};
var PrepaidIsSymbol = {
    reflectSymbol: function () {
        return "Prepaid";
    }
};
var OfflineIsSymbol = {
    reflectSymbol: function () {
        return "Offline";
    }
};
var CashAndCardIsSymbol = {
    reflectSymbol: function () {
        return "CashAndCard";
    }
};
var BankTransferIsSymbol = {
    reflectSymbol: function () {
        return "BankTransfer";
    }
};
var genericTopConstructor = /* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments);
var genericBottomConstructor = /* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments);
var genericBottomSum = /* #__PURE__ */ Data_Bounded_Generic.genericBottomSum(genericBottomConstructor);
var genericEnumConstructor = /* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments);
var genericEnumSum = /* #__PURE__ */ Data_Enum_Generic.genericEnumSum(genericEnumConstructor)(genericTopConstructor);
var genericEnumSum1 = /* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(genericEnumConstructor)(genericBottomConstructor))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum);
var genericBoundedEnumConstructor = /* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments);
var genericBoundedEnumSum = /* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(genericBoundedEnumConstructor);
var genericBoundedEnumSum1 = /* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(genericBoundedEnumConstructor))))));
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney);
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var decodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney);
var SplitPaymentInfo = function (x) {
    return x;
};
var Cash = /* #__PURE__ */ (function () {
    function Cash() {

    };
    Cash.value = new Cash();
    return Cash;
})();
var Online = /* #__PURE__ */ (function () {
    function Online() {

    };
    Online.value = new Online();
    return Online;
})();
var Card = /* #__PURE__ */ (function () {
    function Card() {

    };
    Card.value = new Card();
    return Card;
})();
var Prepaid = /* #__PURE__ */ (function () {
    function Prepaid() {

    };
    Prepaid.value = new Prepaid();
    return Prepaid;
})();
var Offline = /* #__PURE__ */ (function () {
    function Offline() {

    };
    Offline.value = new Offline();
    return Offline;
})();
var CashAndCard = /* #__PURE__ */ (function () {
    function CashAndCard() {

    };
    CashAndCard.value = new CashAndCard();
    return CashAndCard;
})();
var BankTransfer = /* #__PURE__ */ (function () {
    function BankTransfer() {

    };
    BankTransfer.value = new BankTransfer();
    return BankTransfer;
})();
var toFillFormTypeSplitPaymen = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var newtypeSplitPaymentInfo_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldSplitPaymentInfo = function (dictHasField) {
    return dictHasField;
};
var eqSplitPaymentInfo = {
    eq: function (x) {
        return function (y) {
            return eq(x.cardAmount)(y.cardAmount) && eq(x.cashAmount)(y.cashAmount);
        };
    }
};
var eqPaymentMethod = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Cash && y instanceof Cash) {
                return true;
            };
            if (x instanceof Online && y instanceof Online) {
                return true;
            };
            if (x instanceof Card && y instanceof Card) {
                return true;
            };
            if (x instanceof Prepaid && y instanceof Prepaid) {
                return true;
            };
            if (x instanceof Offline && y instanceof Offline) {
                return true;
            };
            if (x instanceof CashAndCard && y instanceof CashAndCard) {
                return true;
            };
            if (x instanceof BankTransfer && y instanceof BankTransfer) {
                return true;
            };
            return false;
        };
    }
};
var ordPaymentMethod = {
    compare: function (x) {
        return function (y) {
            if (x instanceof Cash && y instanceof Cash) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Cash) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Cash) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Online && y instanceof Online) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Online) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Online) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Card && y instanceof Card) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Card) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Card) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Prepaid && y instanceof Prepaid) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Prepaid) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Prepaid) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Offline && y instanceof Offline) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Offline) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Offline) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof CashAndCard && y instanceof CashAndCard) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof CashAndCard) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof CashAndCard) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof BankTransfer && y instanceof BankTransfer) {
                return Data_Ordering.EQ.value;
            };
            throw new Error("Failed pattern match at Restaumatic.Orders.Types.PaymentMethod (line 0, column 0 - line 0, column 0): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqPaymentMethod;
    }
};
var genericSplitPaymentInfo = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showSplitPaymentInfo = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericSplitPaymentInfo)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons(cardAmountIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(cashAmountIsSymbol)(Data_Money_Rounded.showMoney))(Data_Money_Rounded.showMoney))))(SplitPaymentInfoIsSymbol))
};
var unscrambleDecodeSplitPaymentInfo = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecodeTagged(genericSplitPaymentInfo)(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(SplitPaymentInfoIsSymbol)(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons(cardAmountIsSymbol)(Data_Money_Rounded.udecodeMoney)(/* #__PURE__ */ Unscramble.decodeRecordCons(cashAmountIsSymbol)(Data_Money_Rounded.udecodeMoney)(Unscramble.decodeRecordNil)))))(Unscramble_Generic.defaultOptions)
};
var genericPaymentMethod = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Cash.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return Online.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return Card.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return Prepaid.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return Offline.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
            return CashAndCard.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr))))) {
            return BankTransfer.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Types.PaymentMethod (line 56, column 1 - line 56, column 81): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Cash) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Online) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof Card) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof Prepaid) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
        };
        if (x instanceof Offline) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))));
        };
        if (x instanceof CashAndCard) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))));
        };
        if (x instanceof BankTransfer) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value))))));
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Types.PaymentMethod (line 56, column 1 - line 56, column 81): " + [ x.constructor.name ]);
    }
};
var showPaymentMethod = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPaymentMethod)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(CashIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(OnlineIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(CardIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(PrepaidIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(OfflineIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(CashAndCardIsSymbol))(/* #__PURE__ */ genericShowConstructor(BankTransferIsSymbol))))))))
};
var unscrambleDecodePaymentMethod = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Enum.genericUnsafeDecodeEnum(genericPaymentMethod)(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(CashIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(OnlineIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(CardIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(PrepaidIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(OfflineIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(CashAndCardIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(BankTransferIsSymbol))))))))(Unscramble_Enum.defaultEnumOptions)
};
var ufromJSONKeyPaymentMethod = {
    fromJSONKey: /* #__PURE__ */ Unscramble.defaultFromJSONKeyValue(unscrambleDecodePaymentMethod)
};
var boundedPaymentMethod = {
    top: /* #__PURE__ */ Data_Bounded_Generic.genericTop(genericPaymentMethod)(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(genericTopConstructor))))))),
    bottom: /* #__PURE__ */ Data_Bounded_Generic.genericBottom(genericPaymentMethod)(genericBottomSum),
    Ord0: function () {
        return ordPaymentMethod;
    }
};
var enumPaymentMethod = {
    succ: /* #__PURE__ */ Data_Enum_Generic.genericSucc(genericPaymentMethod)(genericEnumSum1),
    pred: /* #__PURE__ */ Data_Enum_Generic.genericPred(genericPaymentMethod)(genericEnumSum1),
    Ord0: function () {
        return ordPaymentMethod;
    }
};
var boundedEnumPaymentMethod = {
    cardinality: /* #__PURE__ */ Data_Enum_Generic.genericCardinality(genericPaymentMethod)(genericBoundedEnumSum1),
    toEnum: /* #__PURE__ */ Data_Enum_Generic.genericToEnum(genericPaymentMethod)(genericBoundedEnumSum1),
    fromEnum: /* #__PURE__ */ Data_Enum_Generic.genericFromEnum(genericPaymentMethod)(genericBoundedEnumSum1),
    Bounded0: function () {
        return boundedPaymentMethod;
    },
    Enum1: function () {
        return enumPaymentMethod;
    }
};
var toFillFormTypePaymentMeth = {
    fillFormDataType: /* #__PURE__ */ Restaumatic_Form_TestHelpers.defaultEnumFillFormDataType(genericPaymentMethod)(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(CashIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(OnlineIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(CardIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(PrepaidIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(OfflineIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(CashAndCardIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(BankTransferIsSymbol))))))))
};
var encodingOptsSplitPaymentInfo = /* #__PURE__ */ (function () {
    return {
        sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
        unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
        fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform,
        unwrapSingleConstructors: true,
        unwrapSingleRecordArguments: true
    };
})();
var encodeSplitPaymentInfo = /* #__PURE__ */ (function () {
    return {
        encode: Foreign_Generic.genericEncode(genericSplitPaymentInfo)(Foreign_Generic_Class.genericEncodeConstructor(SplitPaymentInfoIsSymbol)(Foreign_Generic_Class.genericEncodeArgsRecord(Foreign_Generic_Class.encodeWithOptionsRecord()(encodeRecordCons(encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)(cashAmountIsSymbol)(encodeWithOptionsOther))(cardAmountIsSymbol)(encodeWithOptionsOther)))))({
            sumEncoding: encodingOptsSplitPaymentInfo.sumEncoding,
            unwrapSingleArguments: encodingOptsSplitPaymentInfo.unwrapSingleArguments,
            unwrapSingleRecordArguments: encodingOptsSplitPaymentInfo.unwrapSingleRecordArguments,
            fieldTransform: encodingOptsSplitPaymentInfo.fieldTransform,
            unwrapSingleConstructors: false
        })
    };
})();
var encodePaymentMethod = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEnumEncode(genericPaymentMethod)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(CashIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(OnlineIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(CardIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(PrepaidIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(OfflineIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(CashAndCardIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(BankTransferIsSymbol))))))))
};
var decodeSplitPaymentInfo = /* #__PURE__ */ (function () {
    return {
        decode: Foreign_Generic.genericDecode(genericSplitPaymentInfo)(Foreign_Generic_Class.genericDecodeConstructor(SplitPaymentInfoIsSymbol)(Foreign_Generic_Class.genericDecodeArgsRecord(Foreign_Generic_Class.decodeWithOptionsRecord()(decodeRecordCons(decodeRecordCons(Foreign_Generic_Class.decodeRecordNil)(cashAmountIsSymbol)(decodeWithOptionsOther)())(cardAmountIsSymbol)(decodeWithOptionsOther)())))(Foreign_Generic_Class.genericCountArgsArgument))({
            sumEncoding: encodingOptsSplitPaymentInfo.sumEncoding,
            unwrapSingleArguments: encodingOptsSplitPaymentInfo.unwrapSingleArguments,
            unwrapSingleRecordArguments: encodingOptsSplitPaymentInfo.unwrapSingleRecordArguments,
            fieldTransform: encodingOptsSplitPaymentInfo.fieldTransform,
            unwrapSingleConstructors: false
        })
    };
})();
var decodePaymentMethod = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultEnumDecode(genericPaymentMethod)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(CashIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(OnlineIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(CardIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(PrepaidIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(OfflineIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(CashAndCardIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(BankTransferIsSymbol))))))))
};
var asJSONKeyPaymentMethod = /* #__PURE__ */ (function () {
    return {
        asJSONKey: new Data_Map_Serialized.AsJSONKeyValue(Foreign_Generic_Class.encode(encodePaymentMethod), Foreign_Generic_Class.decode(decodePaymentMethod))
    };
})();
export {
    encodingOptsSplitPaymentInfo,
    SplitPaymentInfo,
    Cash,
    Online,
    Card,
    Prepaid,
    Offline,
    CashAndCard,
    BankTransfer,
    genericSplitPaymentInfo,
    eqSplitPaymentInfo,
    showSplitPaymentInfo,
    encodeSplitPaymentInfo,
    decodeSplitPaymentInfo,
    unscrambleDecodeSplitPaymentInfo,
    toFillFormTypeSplitPaymen,
    hasFieldSplitPaymentInfo,
    newtypeSplitPaymentInfo_,
    genericPaymentMethod,
    eqPaymentMethod,
    showPaymentMethod,
    asJSONKeyPaymentMethod,
    ufromJSONKeyPaymentMethod,
    encodePaymentMethod,
    decodePaymentMethod,
    unscrambleDecodePaymentMethod,
    ordPaymentMethod,
    enumPaymentMethod,
    boundedPaymentMethod,
    boundedEnumPaymentMethod,
    toFillFormTypePaymentMeth
};
